import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TourService {
  private readonly _startTourSignal = signal(false);

  get startTourSignal() {
    return this._startTourSignal.asReadonly();
  }

  triggerTour(): void {
    this._startTourSignal.set(true);
    // Optionally reset after a tick to allow retriggering
    setTimeout(() => this._startTourSignal.set(false), 0);
  }
}